export class UpdatePayerDto {
    name: string
    email?: string
    phone?: string
    addressCEP?: string
    addressStreet?: string
    addressNumber?: string
    addressNeighborhood?: string
    addressCity?: string
    addressState?: string
    addressComplement?: string
}

export class PayerDto {
    customerId: string
    gatewayCustomerId: string
    gatewayId: string
    // identidade da pessoa: nunca editável
    document: string
    name: string
    email?: string
    phone?: string
    addressCEP?: string
    addressStreet?: string
    addressNumber?: string
    addressNeighborhood?: string
    addressCity?: string
    addressState?: string
    addressComplement?: string
    // campos que o gateway atual não deixa alterar; quem decide é o adapter, não a tela
    immutableFields: string[]
    // tudo o que o gateway não aceita alterar depois de gravado; o que não está travado agora ainda
    // pode ser preenchido uma única vez
    gatewayImmutableFields?: string[]
}
